import { ErrorMessage } from "@/app/error"
import { Card } from "@rarible_int/anaconda_ui_components"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import {
  NftSelectorTable,
  NftSelectorTableSkeleton,
} from "./table/nft-selector-table"

// NOTE: useCollectionOffersSync() is called by the parent EvmModernSellDialogContent
// We don't need to call it here to avoid duplicate syncing

export function NftForSellSelector() {
  return (
    <Card className="h-[300px] min-h-[300px] overflow-y-auto px-2">
      <ErrorBoundary
        fallback={
          <div className="flex h-full flex-col items-center justify-center">
            <ErrorMessage />
          </div>
        }
      >
        <Suspense fallback={<NftSelectorTableSkeleton />}>
          <NftSelectorTable />
        </Suspense>
      </ErrorBoundary>
    </Card>
  )
}
